// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const CollectionModelRecord = require('client-v2/common/models/collection/record')
const { keyedReviver } = require('client-v2/common/state/revivers')
const { FetchStateEnum } = require('client-v2/common/utils/enums')

class CollectionEditModalRecord extends Immutable.Record({
  collection: null,
  collectionDeleteState: FetchStateEnum.EMPTY,
  collectionUpdateState: FetchStateEnum.EMPTY,
  headerImageUploadState: FetchStateEnum.EMPTY
}) {
  // No methods
}

CollectionEditModalRecord.reviver = keyedReviver(CollectionEditModalRecord, {
  collection: CollectionModelRecord.reviver
})

module.exports = CollectionEditModalRecord
